import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import UpdatedSidebar from "../components/SidebarUpdate";
import Pagination from "../components/Pagination";

import { ClipLoader } from "react-spinners";

import BaseUrl from "../BaseUrl";
import axios from "axios";

const Wishlist = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchWishlistData = async () => {
    setLoading(true);
    setError(null);
    try {
      const { data } = await axios.get(`${BaseUrl()}/api/style/v1/wishlist/`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      if (data.status === 200) {
        setData(data.data || []);
      } else {
        setData([]);
        setError("No Wishlist Found");
      }
    } catch (error) {
      setError(error?.response?.data?.message || "Failed to load wishlist");
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWishlistData();
  }, []);

  const itemsPerPage = 12;
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = data.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div>
      {error ? (
        <h2 style={{ color: "red", textAlign: "center" }}>{error}</h2>
      ) : (
        <div className="content_wrapper py-4 px-8">
          <UpdatedSidebar />

          <div className="md:ml-[18rem] mt-[5rem] md:mt-0 flex-1 min-h-[75vh]">
            {loading ? (
              <div className="loader-container">
                <ClipLoader color="#3498db" loading={loading} size={50} />
              </div>
            ) : currentData.length === 0 ? (
              <div className="no-products loader-container">
                Like some styles to see them here
              </div>
            ) : (
              <div className="flex flex-col gap-y-2 items-start">
                <h2 className="ml-4">Liked Styles</h2>

                <div className="product_container">
                  {currentData.map((product) => (
                    <div className="cart" key={product.style_id}>
                      <div
                        className="image_container"
                        onClick={() =>
                          navigate(
                            `/wishlist/product-detail/${product.style_id}`
                          )
                        }
                      >
                        <img
                          src={product.cover_image_url}
                          className="image"
                          alt={product.style_name || "Product"}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {data.length > itemsPerPage && (
              <Pagination
                totalItems={data.length}
                itemsPerPage={itemsPerPage}
                currentPage={currentPage}
                onPageChange={handlePageChange}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Wishlist;
